const getBaseUrl = (node_env?: string) => {
    if (!node_env || node_env === 'development') {
        return 'https://testnew.templateroller.com'
    }
    return 'https://www.templateroller.com'
}
const BASE_URL = getBaseUrl(process.env.REACT_APP_ENV)

export function getRedirectToDrawURL(docId: number) {
    return `${BASE_URL}/user-edit/${docId}`
}

export function redirectToDraw(docId: number) {
    window.location.href = `${BASE_URL}/user-edit/${docId}`
}

export function redirectToSearch(name: string) {
    window.location.href = `${BASE_URL}/search/?search_q=${name}`
}

export function stripTags(s: string) {
    return s.replace(/<\/?[^>]+(>|$)/g, "").replace(/\s+/g, '+')
}

export const getCookie = (name: string) => {
    const matches = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`))
    return matches ? decodeURIComponent(matches[1]) : undefined
}